import React, { useEffect, useState } from "react";
import firebase from "./../../firebase";

import { useHistory } from "react-router-dom";
import { useDispatch } from "react-redux";

import { useSelector } from "react-redux";

import * as authActions from "../../store/actions/authActions";
import PreloaderInner from "./../../components/preloader/loader";

// Stylesheet
import "./InfluencerTable.css";

// Assets
import priceEth from "../../assets/eth.svg";
import pricePoly from "../../assets/matic.svg";

import { authFeatureKey, nftFeatureKey } from "../../store/featureKeys";
import { color } from "@mui/system";
import { DataGrid } from '@mui/x-data-grid';
import timeago from 'epoch-timeago';


function InfluencerTable({ nftid, ownerAddress, refreshToken }) {
  const [influencers, setInfluencers] = useState([]);
  const limit = 5;
  useEffect(async () => {
    let influencersList = [];
    if (nftid) {
        await firebase
        .firestore()
        .collection("NFTPromotionList")
        .limit(1)
        .where("nftid", "==", nftid)
        .where("promotedBy", "==", ownerAddress)
        .where("listed", "==", true)
        .orderBy("createdAt", "desc")
        .get()
        .then((querySnapshot) => {
            if (querySnapshot.empty) {
            return;
            } else {
                querySnapshot.forEach((doc) => {
                    var influencers = doc.data().influencers;
                    var count = 0;
                    influencers.forEach((inf) => {
                        var document = inf;
                        document.id = count;
                        document.budget = doc.data().maximumPricePerTweet;
                        document.createdAt = timeago(doc.data().createdAt.toDate());
                        count = count + 1;
                        influencersList.push(document);
                    });
                    setInfluencers(influencersList);
                });
            }
        })
        .catch((error) => {
            console.log("Influencer Error", error);
        });
    }
  }, [nftid, ownerAddress, refreshToken]);

  const columns = [
    { field: 'handle', headerName: 'Twitter Handle', width: 300, 
        renderCell: (params) => (
        <div>
            <a href={params.value.twitter} style={{textDecoration: "none", borderBottom: "1px solid #d3aa4b"}} target="_blank" > {params.value.username} </a>
        </div>
        )
    },
    { field: 'status', headerName: 'Status', width: 300 },
    { field: 'budget', headerName: 'Budget', width: 100 },
    { field: 'createdAt', headerName: 'Created', width: 240}
  ];

  return influencers.length > 0 && (
    <div style={{height: 400, maxHeight: 400}}>
      <p style={{marginTop: "40px", fontSize: "28px"}}>Promoters</p>
      <DataGrid
        rows={influencers}
        columns={columns}
        pageSize={limit}
        rowsPerPageOptions={[limit]}
      />
    </div>
  );
}

export default InfluencerTable;